import { State } from './state';

import { areasAll } from '@studyportals/static-domain-data/areas/areas';

class StatePresenter {
	public all(): Promise<readonly State[]> {
		const areas = areasAll.map((a) => new State(a.id, a.name, a.countryId));

		return Promise.resolve(areas);
	}

	public async forCountries(countryIds: readonly string[]): Promise<readonly State[]> {
		const setCountryIds = new Set<string>(countryIds);

		const areas = await this.all();
		const areasRelevant = areas.filter((a) => setCountryIds.has(a.countryId));

		return Promise.resolve(areasRelevant);
	}

	public async retrieveMultiple(ids: readonly string[]): Promise<readonly State[]> {
		const areas = await this.all();
		const areasRelevant = areas.filter((a) => ids?.includes(a.id));

		return Promise.resolve(areasRelevant);
	}
}

export default new StatePresenter();
